<template>
    <Card :bordered="false" dis-hover class="importNoticeQuery">
        <Form :model="formItem" :rules="formItemRules"
              :label-width="100"
              :style="{maxHeight: collapse[collapseType].maxHeight, overflow: collapse[collapseType].overflow}"
              ref="searchForm">
            <Row>
                <Col span="20">
                <Row>
                    <Col span="8">
                        <!-- 库存组织 -->
                        <FormItem :label="$t('importNoticeCommon.t2')" prop="orgCode" :rules="{required: true, message: $t('importNoticeCommon.t3'), trigger: 'change'}">
                            <Select v-model="formItem.orgCode"
                                    placeholder="" size="small"
                                    :filterable="true"
                                    :disabled= !orgList.length
                                    :clearable="true">
                                <Option v-for="(item, index) in orgList" :value="item.value" :key="index">{{item.label}}
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <FormItem :label="$t('importNoticeCommon.t5')">
                            <Row :gutter="0">
                                <Col span="11">
                                    <!-- 只能输入数字和英文 -->
                                    <FormItem label="" prop="startImptNumber" :rules="[{pattern: /^[a-zA-Z0-9]+$/, message: $t('importNoticeCommon.t6'), trigger: 'blur'}]">
                                        <Input v-model.trim="formItem.startImptNumber" size="small"></Input>
                                    </FormItem>
                                </Col>
                                <Col span="2" style="text-align: center">-</Col>
                                <Col span="11">
                                    <FormItem label="" prop="endImptNumber" :rules="[{pattern: /^[a-zA-Z0-9]+$/, message: $t('importNoticeCommon.t6'), trigger: 'blur'}]">
                                        <Input v-model.trim="formItem.endImptNumber" size="small"></Input>
                                    </FormItem>
                                </Col>
                            </Row>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <!-- 单据状态 -->
                        <FormItem :label="$t('importNoticeCommon.t7')" prop="imptStatus" :rules="{required: false, message: $t('importNoticeCommon.t3'), trigger: 'change'}">
                            <Select v-model="formItem.imptStatus"
                                    placeholder="" size="small"
                                    :filterable="true"
                                    :disabled= !cuxInStatusList.length
                                    :clearable="true" @on-change="onStatusChange">
                                <Option v-for="(item, index) in cuxInStatusList" :value="item.value" :key="index">{{item.label}}
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="8">
                        <!-- 创建时间 -->
                        <FormItem :label="$t('importNoticeCommon.t8')" required>
                            <Row :gutter="0">
                                <Col span="11">
                                    <!-- 日期从 -->
                                    <FormItem prop="startCreationDate" placeholder="">
                                        <DatePicker type="date" v-model="formItem.startCreationDate" placeholder="" format="yyyy-MM-dd" placement="bottom" style="width:100%" :option="options" size="small"></DatePicker>
                                    </FormItem>
                                </Col>
                                <Col span="2" style="text-align: center">-</Col>
                                <Col span="11">
                                    <!-- 日期至 -->
                                    <FormItem prop="endCreationDate" :label-width="0">
                                        <DatePicker type="date" v-model="formItem.endCreationDate" placeholder="" format="yyyy-MM-dd" placement="bottom" style="width:100%" :option="options" size="small"></DatePicker>
                                    </FormItem>
                                </Col>
                            </Row>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <!-- 物料编码 -->
                        <FormItem :label="$t('importNoticeCommon.t9')">
                            <Row :gutter="0">
                                <Col span="11">
                                    <FormItem label="" prop="startItemCode" :rules="[{pattern: /^[a-zA-Z0-9]+$/, message: $t('importNoticeCommon.t6'), trigger: 'blur'}]">
                                        <Input v-model.trim="formItem.startItemCode" size="small"></Input>
                                    </FormItem>
                                </Col>
                                <Col span="2" style="text-align: center">-</Col>
                                <Col span="11">
                                    <FormItem label="" prop="endItemCode" :rules="[{pattern: /^[a-zA-Z0-9]+$/, message: $t('importNoticeCommon.t6'), trigger: 'blur'}]">
                                        <Input v-model.trim="formItem.endItemCode" size="small"></Input>
                                    </FormItem>
                                </Col>
                            </Row>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <!-- 采购订单号 -->
                        <FormItem :label="$t('importNoticeCommon.t10')">
                            <Row :gutter="0">
                                <Col span="11">
                                    <FormItem label="" prop="startPoNumber" :rules="[{pattern: /^[a-zA-Z0-9]+$/, message: $t('importNoticeCommon.t6'), trigger: 'blur'}]">
                                        <Input v-model.trim="formItem.startPoNumber" size="small"></Input>
                                    </FormItem>
                                </Col>
                                <Col span="2" style="text-align: center">-</Col>
                                <Col span="11">
                                    <FormItem label="" prop="endPoNumber" :rules="[{pattern: /^[a-zA-Z0-9]+$/, message: $t('importNoticeCommon.t6'), trigger: 'blur'}]">
                                        <Input v-model.trim="formItem.endPoNumber" size="small"></Input>
                                    </FormItem>
                                </Col>
                            </Row>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="8">
                        <!-- 报关单号 -->
                        <FormItem :label="$t('importNoticeCommon.t11')">
                            <Row :gutter="0">
                                <Col span="11">
                                    <FormItem label="" prop="startCustomsNumber" :rules="[{pattern: /^[a-zA-Z0-9]+$/, message: $t('importNoticeCommon.t6'), trigger: 'blur'}]">
                                        <Input v-model.trim="formItem.startCustomsNumber" size="small"></Input>
                                    </FormItem>
                                </Col>
                                <Col span="2" style="text-align: center">-</Col>
                                <Col span="11">
                                    <FormItem label="" prop="endCustomsNumber" :rules="[{pattern: /^[a-zA-Z0-9]+$/, message: $t('importNoticeCommon.t6'), trigger: 'blur'}]">
                                        <Input v-model.trim="formItem.endCustomsNumber" size="small"></Input>
                                    </FormItem>
                                </Col>
                            </Row>
                        </FormItem>
                    </Col>
                    <Col span="8">
                        <!--商业发票号-->
                        <!-- 报关单号 -->
                        <FormItem :label="$t('invoiceMonitoring.t8')">
                            <Row :gutter="0">
                                <Col span="24">
                                    <FormItem label="" prop="supplierInvoiceNumber">
                                        <Input v-model.trim="formItem.supplierInvoiceNumber" size="small"></Input>
                                    </FormItem>
                                </Col>
                            </Row>
                        </FormItem>
                    </Col>
                </Row>
                </Col>
                <Col span="4" style="float: right; width: 175px;">
                <Row type="flex" justify="end" align="middle">
                    <Col span="24" style="padding-top: 5px;text-align: right;">
                    <!-- <div style="line-height: 38px;min-width: 125px;"> -->
                        <!-- <a class="btn-collapse" href="javascript: void(0)" @click="handleCollapse" style="margin: 0 2px 0 10px;">
                            {{collapse[collapseType].text}}
                        </a> -->
                        <a class="btn-collapse mg-ll-10" href="javascript: void(0)" @click="handleCollapse">
                            <Icon :type="collapse[collapseType].icon"></Icon>
                        </a>
                        <Button type="primary" size="small" class="mg-ll-10" @click="onSubmit" :loading="loading">{{$t('common.queryBtn')}}
                        </Button>
                        <Button type="ghost" size="small" class="mg-ll-5" @click="handleConfirmReset">{{$t('common.clearBtn')}}
                        </Button>
                    <!-- </div> -->
                    </Col>
                </Row>
                </Col>
            </Row>
        </Form>
        <div>
            <Form>
                <Row :gutter="0">
                <Col span="16">
                    <!-- 新增 导出 -->
                    <Button type="primary" class="each-btn" @click="handleAdd" :loading="loading">{{$t('common.newBtn')}}</Button>
                    <Button type="primary" class="each-btn" @click="handleExport" :loading="loading" :disabled="tableData.length === 0">{{$t('common.export')}}</Button>
                    <set-table class="each-btn" :columns="columns" @setTableUpdate="setTableUpdate"></set-table>
                </Col>
                </Row>
            </Form>
        </div>
        <div class="pagination">
            <Table size="small" thDrag :columns="columns" :data="tableData" :loading="loading" height="400" stripe highlight-row border @on-selection-change="onSelectionChange" ref="table"></Table>
            <m-pagination v-if="settings.needPager"
                        :showElevator="settings.showElevator"
                        :showSizer="settings.showSizer"
                        :currentPage="settings.currentPage"
                        :pageSize="settings.pageSize"
                        :total="settings.pageTotal"
                        :pageSizeOpts="settings.pageSizeOpts"
                        @on-page-size-change="onPageSizeChange"
                        @on-current-page-change="onPageChange"
            ></m-pagination>
        </div>
    </Card>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import mPagination from '@/components/awesome/page/pagination/main';
export default {
    name: 'importNoticeQuery',
    components: {
        mPagination
    },
    data() {
        return {
            vendorCode: '',
            orgList: [],
            cuxDeliveryAssociatedDecList: [], // 组织快码
            cuxInStatusList: [], // 单据状态
            intTypeOfPakageList: [], // 包装种类
            settings: {
                needValidation: false,
                needPager: true,
                showElevator: true,
                showSizer: true,
                currentPage: 1,
                pageTotal: 0,
                pageSize: 10,
                pageSizeOpts: [10, 30, 50, 80],
                needSearch: false
            },
            formItem: {
                orgCode: '',            // 库存组织
                startImptNumber: '',    // 通知书号开始
                endImptNumber: '',      // 通知书号结束
                imptStatus: '',         // 单据状态,默认草稿?
                startCreationDate: moment(new Date()).subtract(1, 'M')._d, // 创建时间开始
                endCreationDate: new Date().getTime(), // 创建时间结束
                startItemCode: '',      // 物料编码从
                endItemCode: '',        // 物料编码至
                startPoNumber: '',      // 采购订单号开始
                endPoNumber: '',        // 采购订单号结束
                startCustomsNumber: '', // 报关单号开始
                endCustomsNumber: '',   // 报关单号结束
                supplierInvoiceNumber: ''
            },
            formItemRules: {
                startCreationDate: [
                    {type: 'date', required: true, message: this.$t('importNoticeCommon.t3'), trigger: 'change'}
                ],
                endCreationDate: [
                    {type: 'date', required: true, message: this.$t('importNoticeCommon.t3'), trigger: 'change'}
                ]
            },
            options: {
                disabledDate(date) {
                    var dt = new Date();
                    dt.setMonth(dt.getMonth() - 12);
                    return date && date.valueOf() < dt;
                }
            },
            loading: false,
            columns: [
                {
                    title: this.$t('common.sequence'), // 序号
                    type: 'index',
                    minWidth: 60,
                    align: 'center'
                },
                {
                    title: this.$t('importNoticeCommon.t80'), // '操作'
                    key: 'opt',
                    sortable: false,
                    align: 'center',
                    minWidth: 90,
                    render: (h, params) => {
                        let flag = params.row.imptStatus;
                        let bh = h('div', [
                                h('a', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    display: 'none',
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.handleEdit(params.row);
                                        }
                                    }
                                }, this.$t('importNoticeCommon.t12')), // 修改
                                h('a', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    display: 'none',
                                    on: {
                                        click: () => {
                                            this.$Modal.confirm({
                                                title: this.$t('common.warn'),
                                                content: this.$t('importNoticeCommon.t16'), // 确定要废弃吗？
                                                onOk: () => {
                                                    setTimeout(() => {
                                                        this.handCanceled({headerId: params.row.headerId});
                                                    }, 300);
                                                }
                                            });
                                        }
                                    }
                                }, this.$t('importNoticeCommon.t13')) // 作废
                            ]);
                        let cg = h('div', [
                                h('a', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    display: 'none',
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.handleEdit({headerId: params.row.headerId});
                                        }
                                    }
                                }, this.$t('importNoticeCommon.t12')), // 修改
                                h('a', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.handleDel(params.row.headerId);
                                        }
                                    }
                                }, this.$t('importNoticeCommon.t14')) // 删除
                            ]);
                        let sp = h('div', [
                                h('a', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.handShow({headerId: params.row.headerId});
                                        }
                                    }
                                }, this.$t('importNoticeCommon.t15')) // 查看
                            ]);
                        let ck = h('div', [
                                h('a', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.handShow({headerId: params.row.headerId});
                                        }
                                    }
                                }, this.$t('importNoticeCommon.t15')) // 查看
                            ]);
                        switch (flag) {
                            case 'DRAFT':
                                return cg;
                            case 'APPROVED':
                            case 'APPROVING':
                                return sp;
                            case 'REJECT':
                                return cg;
                            case 'CANCELED':
                                return ck;
                            case 'OBSOLETE':
                                return ck;
                            case 'SUBMITTED':
                                return ck;
                            case 'DECLARED':
                                // 已报关
                                return ck;
                            default:
                                return ck;
                        }
                    }
                },
                {
                    title: this.$t('importNoticeCommon.t7'), // 单据状态
                    key: 'imptStatus',
                    tooltip: true,
                    align: 'center',
                    minWidth: 100,
                    render: (h, params) => {
                        let obj = this.cuxInStatusList.find(item => item.value === params.row.imptStatus);
                        if (obj && obj.label) {
                            return h('span', {}, obj.label);
                        } else {
                            return h('span', {});
                        }
                    }
                },
                {
                    title: this.$t('importNoticeCommon.t5'), // 通知书号
                    key: 'imptNumber',
                    sortable: true,
                    tooltip: true,
                    minWidth: 120,
                    sortable: true
                },
                // {
                //     title: this.$t('importNoticeCommon.t17'), // 关区名称
                //     key: 'customsName',
                //     sortable: true,
                //     tooltip: true,
                //     minWidth: 160
                // },
                {
                    title: this.$t('importNoticeCommon.t11'), // '报关单号',
                    key: 'customsNumber',
                    sortable: true,
                    tooltip: true,
                    minWidth: 120,
                    sortable: true
                },
                {
                    title: this.$t('importNoticeCommon.t19'), // '备注',
                    key: 'remarks',
                    tooltip: true,
                    minWidth: 160
                },
                {
                    title: this.$t('importNoticeCommon.t2'), // '库存组织',
                    key: 'orgName',
                    tooltip: true,
                    minWidth: 160
                },
                {
                    title: this.$t('importNoticeCommon.t8'), // '创建时间',
                    key: 'creationDate',
                    align: 'center',
                    sortable: true,
                    minWidth: 130,
                    render: (h, params) => {
                        let timesfmt = params.row.creationDate ? moment(params.row.creationDate).format('YYYY-MM-DD HH:mm:ss') : '';
                        return h('span', {}, timesfmt);
                    },
                    sortable: true
                },
                {
                    title: this.$t('importNoticeCommon.t84'), // '预计发船日期',
                    key: 'etd',
                    sortable: true,
                    minWidth: 130
                },
                {
                    title: this.$t('importNoticeCommon.t85'), // '预计到港日期',
                    key: 'eta',
                    sortable: true,
                    minWidth: 130
                },
                {
                    title: this.$t('importNoticeCommon.t86'), // '包装种类',
                    key: 'typeOfPackage',
                    tooltip: true,
                    sortable: true,
                    minWidth: 130,
                    render: (h, params) => {
                        let obj = this.intTypeOfPakageList.find(item => item.value === params.row.typeOfPackage);
                        if (obj && obj.label) {
                            return h('span', {}, obj.label);
                        } else {
                            return h('span', {});
                        }
                    }
                },
                {
                    title: this.$t('importNoticeCommon.t87'), // '提运单号',
                    key: 'billNo',
                    tooltip: true,
                    sortable: true,
                    minWidth: 130
                },
                {
                    title: this.$t('importNoticeCommon.t88'), // '进口日期',
                    key: 'iEDate',
                    sortable: true,
                    minWidth: 130
                },
            ],
            collapse: {
                up: {
                    text: this.$t('common.retract'), // '收起',
                    icon: 'chevron-up',
                    maxHeight: '240px',
                    overflow: 'visible'
                },
                down: {
                    text: this.$t('common.expand'), // 展开
                    icon: 'chevron-down',
                    maxHeight: '40px',
                    overflow: 'hidden'
                }
            },
            collapseType: 'up',
            tableData: [],
            selection: []
        }
    },
    methods: {
        /** 收起展开**/
        handleCollapse() {
            if (this.collapseType === 'up') {
                this.collapseType = 'down';
            } else {
                this.collapseType = 'up';
            }
        },
        /** 清除**/
        handleConfirmReset() {
            this.$refs['searchForm'].resetFields();
        },
        /** 验证正整数 */
        validatePositive(val) {
            var rel = /^[0-9]*[1-9][0-9]*$/;
            return rel.test(val);
        },
        onStatusChange(val) {
            console.log('val:', val);
        },
        /** 当前页改变时触发 */
        onPageChange(currentPage) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        /** 页容量改变时触发 */
        onPageSizeChange(pageSize) {
            this.settings.currentPage = 1;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        showTips(msg) {
            this.$Modal.error({
                title: this.$t('common.warn'),
                content: msg
            });
        },
        validAll() {
            let flag = true;
            this.$refs['searchForm'].validate((valid) => {
                if (valid) {
                    flag = true;
                    let startCreationDate = this.formItem.startCreationDate ? moment(this.formItem.startCreationDate).format('YYYY-MM-DD') : '';
                    let endCreationDate = this.formItem.endCreationDate ? moment(this.formItem.endCreationDate).format('YYYY-MM-DD') : '';
                    if (!startCreationDate || !endCreationDate) {
                        this.$Message.error(this.$t('importNoticeCommon.t20')); // 创建时间区间必选
                        flag = false;
                        return false;
                    }
                    if (startCreationDate && endCreationDate) {
                        if (new Date(startCreationDate).getTime() > new Date(endCreationDate).getTime()) {
                            this.$Message.error(this.$t('importNoticeCommon.t21')); // 创建时间开始日期不能超过结束日期
                            flag = false;
                        }
                        // else if (moment(startCreationDate).format('x') < moment(endCreationDate).subtract('12', 'M').format('x')) {
                        //     this.$Message.error('创建时间范围最大不能超过12个月');
                        //     flag = false;
                        // }
                    }
                } else {
                    flag = false;
                }
            });
            return flag;
        },
        onSubmit() {
            this.settings.currentPage = 1;
            this.settings.pageSize = this.settings.pageSize;
            this.onSearch();
        },
        /** 搜索 */
        onSearch() {
            if (!this.validAll()) {
                return false;
            }
            let params = {...this.formItem};
            params.startCreationDate = params.startCreationDate ? moment(params.startCreationDate).format('YYYY-MM-DD 00:00:00') : ''; // 创建时间开始
            params.endCreationDate = params.endCreationDate ? moment(params.endCreationDate).format('YYYY-MM-DD 23:59:59') : ''; // 创建时间结束
            this.loading = true;
            this.selection = [];
            this.tableData = [];
            axios.post('/gscint/imptNotyHeader/headerList', {
                vendorCode: this.vendorCode,
                orgCode: params.orgCode,
                page: this.settings.currentPage,
                pageSize: this.settings.pageSize,
                ...params
            }).then(res => {
                this.loading = false;
                let rep = res.data;
                if (rep.data.success === true) {
                    if (rep.data.data.rows) {
                        this.tableData = rep.data.data.rows;
                        this.settings.pageTotal = rep.data.data.total;
                    } else {
                        this.tableData = [];
                        this.settings.pageTotal = 0;
                    }
                } else {
                    this.showTips(rep.data.message);
                }
            })
            .catch(() => {
                this.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        onSelectionChange(selection) {
            console.log('selection::', selection);
            this.selection = selection;
        },
        /** 新增 */
        handleAdd() {
            let params = {};
            this.$router.push({name: 'importNoticeAdd', params});
        },
        /** 编辑 */
        handleEdit({headerId}) {
            this.$router.push({
                path: '/purchaseDistribution/importNoticeEdit',
                query: {
                    headerId
                }
            });
        },
        /** 查看 */
        handShow({headerId}) {
            this.$router.push({
                path: '/purchaseDistribution/importNoticeRead',
                query: {
                    headerId
                }
            });
        },
        /** 作废 */
        handCanceled(ob) {
            let params = {};
            params.header = {
                headerId: ob.headerId,
                imptStatus: 'OBSOLETE'
            }
            this.loading = true;
            axios.post('/gscint/imptNotyHeader/headerUpdate', params).then((res) => {
                if (res.data.success) {
                    this.$Message.success({
                        content: this.$t('importNoticeCommon.t22'), // 已作废
                        duration: 3
                    });
                    setTimeout(() => {
                        this.onSearch();
                    }, 200);
                } else {
                    this.loading = false;
                    this.showTips(rep.data.message);
                }
            }).catch(() => {
                this.loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        handleDel(headerId) {
            this.$Modal.confirm({
                content: `<p> ${this.$t('importNoticeCommon.t23')} </p>`, // 确定要删除吗？
                onOk: () => {
                    axios.get(`/gscint/imptNotyHeader/headerDel?headerId=${headerId}`)
                    .then(res => {
                        try {
                            if (res.data.data.success) {
                                this.onSearch();
                            }
                        } catch (error) {
                            console.log(error);
                        }
                    });
                }
            });
        },
        /** 全部导出 */
        handleExport() {
            if (!this.validAll()) {
                return false;
            }
            this.loading = true;
            var a = document.createElement('a');
            let params = {...this.formItem};
            params.startCreationDate = params.startCreationDate ? moment(params.startCreationDate).format('YYYY-MM-DD 00:00:00') : ''; // 创建时间开始
            params.endCreationDate = params.endCreationDate ? moment(params.endCreationDate).format('YYYY-MM-DD 23:59:59') : ''; // 创建时间结束
            params.page = 1;
            params.pageSize = 999999;

            a.href = '/gscint/imptNotyHeader/export?paraJson=' + encodeURI(JSON.stringify(params));
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            a.remove();
            setTimeout(() => {
                this.loading = false;
            }, 5000);
        },
        setTableUpdate(columns) {
            this.columns = columns;
        },
    },
    async mounted() {
        this.vendorCode = JSON.parse(window.localStorage.supplierInfo).vendorCode;
        /** 单据状态 */
        this.getDict('INT_IMPT_STATUS', (data) => {
            this.cuxInStatusList = data;
        });
        /** 包装种类 */
        this.getDict('INT_TYPE_OF_PAKAGE', (data) => {
            this.intTypeOfPakageList = data;
        });
        /*过滤组织*/
        await this.getDict('INT_CUX_DELIVERY_ASSOCIATED_DEC');
        // 获取组织
        this.getSRMInvLovListNew((data) => {
            let list = [];
            /* 过滤组织 */
            let filterOrg = [];
            this.INT_CUX_DELIVERY_ASSOCIATED_DEC.forEach((item) => {
               filterOrg.push(item.code); 
            });
            data.forEach((item) => {
                if (filterOrg.includes(item.organizationCode)) {
                    list.push({
                        label: item.organizationName,
                        value: item.organizationCode,
                        erpOrgId: item.erpOrgId
                    });
                }
            });
            this.orgList = list;
        });
    },
    activated() {
        if (this.formItem.orgCode) {
            this.onSubmit();
        }
    }
};
</script>

<style lang='less'>
    .importNoticeQuery{
        padding: 16px;
        .m-card-body{
            padding: 0px;
        }
        .each-btn {
            margin: 8px 8px 8px 0;
        }
        .m-input-wrapper {
            z-index: 0;
        }
        .mg-ll-5{
            margin-left: 5px;
        }
        .mg-ll-10{
            margin-left: 10px;
        }
    }
</style>
